import styled from 'styled-components';
import { Accordion } from '../../atoms';
export const FaqAccordion = styled(Accordion)`
  div + div:last-child {
    -webkit-line-clamp: unset;
    max-height: 100%;
    ${props => props.open ? `
            max-height: 100%;
          ` : `
            max-height: 0px;
          `}
  }
`;